import { getConfigureErrors, getGenericError, getQuantityError } from '@msdyn365-commerce-modules/buybox';
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Alert, getTelemetryObject, INodeProps, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import { IAddToCartFailureResult } from '@msdyn365-commerce/components';
import { getUrlSync, IImageSettings } from '@msdyn365-commerce/core';
import * as React from 'react';
import AddToCartComponent from '../../../themes/mattressfirm/views/components/addtocart';
import _getInventoryQuantity from '../../../Utilities/get-inventory-quantity';
import { IBuyboxViewPropsExtended } from '../types';
import { IMfrmBuyboxResources } from '../mfrm-buybox.props.autogenerated';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
export interface IMfrmBuyboxAddToCartViewProps {
    ContainerProps?: INodeProps;
    errorBlock?: React.ReactNode;
    button?: React.ReactNode;
}
export interface IBuyboxErrorBlockProps {
    configureErrors: { [configureId: string]: string | undefined };
    quantityError?: string;
    customAmountError?: string;
    otherError?: string;
    resources: IMfrmBuyboxResources;
    showError: boolean;
}

let telemetryContent: ITelemetryContent;
let outOfStockSmallParcel: boolean = false;
let outOfStockBoolean: boolean | undefined = false;
export const BuyboxErrorBlock: React.FC<IBuyboxErrorBlockProps> = ({ showError, configureErrors, quantityError, customAmountError, otherError, resources }) => {
    let errorMessages: (string | undefined)[] = [];

    errorMessages = Object.values(configureErrors).filter(message => message !== undefined);

    if (quantityError) {
        errorMessages.push(quantityError);
    }

    if (customAmountError) {
        errorMessages.push(customAmountError);
    }

    if (otherError) {
        errorMessages.push(otherError);
    }

    return (
        <Alert
            isOpen={showError && errorMessages.length > 0}
            color='danger'
            assertive={true}
            aria-label={resources.buyboxErrorMessageHeader}
        >
            <div className='msc-alert__header' aria-hidden='true'>
                <span className='msi-exclamation-triangle' />
                <span>{resources.buyboxErrorMessageHeader}</span>
            </div>
            {errorMessages.map((message, index) => {
                return (
                    <div key={index} className='msc-alert__line'>
                        {message}
                    </div>
                );
            })}
        </Alert>
    );
};

// tslint:disable-next-line:max-func-body-length cyclomatic-complexity
export function mfrmgetBuyboxAddToCart(
    props: IBuyboxViewPropsExtended,
    defaultMinimumKeyInPrice: number,
    defaultMaximumKeyInPrice: number,
    variantOutOfStock: boolean,
    itemOutOfMarket: boolean,
    outOfStockSmallParcelState: boolean,
    adjustableItem: SimpleProduct | undefined,
    pillow: SimpleProduct | undefined,
    protector: SimpleProduct | undefined
): IMfrmBuyboxAddToCartViewProps {
    const {
        id,
        typeName,
        context,
        data: {
            product: { result: product },
            productPrice: { result: productPrice },
            productAvailableQuantity: { result: productAvailableQuantity },
            productSpecificationData,
            categoryPaths
        },
        resources,
        config: { minimumKeyInPrice, maximumKeyInPrice },
        app: {
            config: { brandBackofficeAttributePdp }
        }
    } = props;
    const allCategoriesArr = categoryPaths?.result;
    const categoryObj = allCategoriesArr && allCategoriesArr[allCategoriesArr?.length - 1];
    const categoryName: string | undefined = categoryObj ? `${categoryObj?.Name}` : undefined;
    const fallBackBrandAttribute = 'VENDOR BRAND';
    const attribute = brandBackofficeAttributePdp || fallBackBrandAttribute;
    const attributes = productSpecificationData.result;
    let productBrandName =
        attributes &&
        attributes.find(currAttribute => currAttribute.Name && currAttribute.Name.toLowerCase().trim() === attribute.toLowerCase().trim())
            ?.TextValue;
    productBrandName = productBrandName ? `${productBrandName}` : undefined;
    const {
        quantity,
        errorState: { configureErrors, quantityError, customAmountError, otherError, errorHost },
        selectedProduct,
        isUpdatingDimension,
        isUpdatingDeliveryOptions,
        isServiceItem,
        keyInPriceAmount
    } = props.state;
    let allVariantOOS = false;
    const { ecomAllVairantStockInfoConcatenated } = props;
    if (ecomAllVairantStockInfoConcatenated && ecomAllVairantStockInfoConcatenated.length > 0) {
        for (let i = 0;i < props.ecomAllVairantStockInfoConcatenated.length;i++) {
            const variantIdOOS = ecomAllVairantStockInfoConcatenated[i].split('|');
            if (variantIdOOS && variantIdOOS[0] && variantIdOOS[1] && variantIdOOS[1] !== '0') {
                allVariantOOS = true;
            } else {
                allVariantOOS = false;
                break;
            }
        }
    }
    const lastBreadcrumbCategoryLink = categoryPaths && categoryPaths.result && categoryPaths?.result[categoryPaths?.result.length - 1];
    const outOfStockValue = productSpecificationData.result?.filter((specificationData) => {
        return specificationData.Name?.trim().toLowerCase() === props.context.app.config.outOfStockProductKey?.trim().toLowerCase();
    });

    const shippingInformationSmall = productSpecificationData.result?.find(
        attr => attr.Name?.trim() === props.context.app.config.smallParcelAttributeKey
    )?.TextValue;
    outOfStockBoolean = outOfStockValue && outOfStockValue[0] && outOfStockValue[0].BooleanValue;
    outOfStockBoolean ? (outOfStockSmallParcel = true) : (outOfStockSmallParcel = false);
    if (outOfStockBoolean === null || outOfStockBoolean === undefined) {
        outOfStockSmallParcel = false;
    }

    // checked product small parcel and drop ship product type
    if (shippingInformationSmall && _getProductType(shippingInformationSmall.toLowerCase()) === 'Drop Ship') {
        if (outOfStockBoolean) {
            outOfStockSmallParcel = true;
        } else {
            outOfStockSmallParcel = false;
        }
    } else if (shippingInformationSmall && _getProductType(shippingInformationSmall.toLowerCase()) === 'Small Parcel') {
        // tslint:disable-next-line: no-floating-promises
        if (outOfStockBoolean) {
            outOfStockSmallParcel = true;
        } else {
            const checkSPAvailibility = props.state?.variantAvailibilityList?.find((variant) => variant.variantID === product?.RecordId);
            if (checkSPAvailibility && !checkSPAvailibility?.isAvailable) {
                if (!props.state?.variantAvailibilityList?.some(variant => variant.isAvailable && variant.variantID !== product?.RecordId)) {
                    outOfStockSmallParcel = true;
                }
            } else {
                outOfStockSmallParcel = false;
            }
        }
    } else if (shippingInformationSmall && _getProductType(shippingInformationSmall.toLowerCase()) === 'Core') {
        if (outOfStockBoolean) {
            outOfStockSmallParcel = true;
        } else {
            outOfStockSmallParcel = false;
        }
    }
    const productAvailability = props.state.productAvailableQuantity
        ? props.state.productAvailableQuantity.ProductAvailableQuantity
        : productAvailableQuantity && productAvailableQuantity.length
            ? productAvailableQuantity[0].ProductAvailableQuantity
            : undefined;

    const onAddToCartFailed = (result: IAddToCartFailureResult) => {
        let quantityErrorForState: string | undefined;
        let customAmountErrorForState: string | undefined;
        // VSI Performance Customization - used cart props.data.cart.result
        let otherErrorForState: string | undefined = getGenericError(
            result,
            props.data.cart.result,
            resources,
            context,
            product,
            productAvailability,
            undefined
        );

        if (result.failureReason === 'OUTOFSTOCK') {
            quantityErrorForState = result.failureReason === 'OUTOFSTOCK' ? getQuantityError(result.stockLeft, resources) : undefined;
        } else if (
            result.failureReason === 'CARTACTIONFAILED' &&
            result.cartActionResult &&
            (result.cartActionResult.substatus === 'MAXQUANTITY' || result.cartActionResult.substatus === 'QUANTITYLIMITS')
        ) {
            // VSI Performance Customization - used cart props.data.cart.result
            quantityErrorForState = getGenericError(
                result,
                props.data.cart.result,
                resources,
                context,
                product,
                productAvailability,
                undefined
            );
            otherErrorForState = undefined; // prevent error duplication in otherError and quantityError
        }

        if (result.failureReason === 'INVALIDCUSTOMAMOUNT') {
            if (keyInPriceAmount === undefined || keyInPriceAmount < (minimumKeyInPrice || defaultMinimumKeyInPrice)) {
                const formatedAmountLimit = props.context.cultureFormatter.formatCurrency(minimumKeyInPrice || defaultMinimumKeyInPrice);
                customAmountErrorForState = resources.invalidSmallCustomAmountText?.replace('{minAmount}', formatedAmountLimit);
            } else if (keyInPriceAmount > (maximumKeyInPrice || defaultMaximumKeyInPrice)) {
                const formatedAmountLimit = props.context.cultureFormatter.formatCurrency(maximumKeyInPrice || defaultMaximumKeyInPrice);
                customAmountErrorForState = resources.invalidLargeCustomAmountText?.replace('{maxAmount}', formatedAmountLimit);
            }
        }

        props.callbacks.updateErrorState({
            errorHost: 'ADDTOCART',
            quantityError: quantityErrorForState,
            configureErrors:
                result.failureReason === 'MISSINGDIMENSION'
                    ? getConfigureErrors(result.missingDimensions, resources, product?.IsGiftCard)
                    : {},
            customAmountError: customAmountErrorForState,
            otherError: otherErrorForState
        });
    };

    const dialogStrings = {
        goToCartText: resources.buyBoxGoToCartText,
        continueShoppingText: resources.buyBoxContinueShoppingText,
        headerItemOneText: resources.buyBoxSingleItemText,
        headerItemFormatText: resources.buyBoxMultiLineItemFormatText,
        headerMessageText: resources.buyBoxHeaderMessageText,
        freePriceText: resources.priceFree,
        originalPriceText: resources.originalPriceText,
        currentPriceText: resources.currentPriceText
    };

    const defaultImageSettings: IImageSettings = {
        viewports: {
            xs: { q: `w=240&h=240&m=6`, w: 0, h: 0 },
            lg: { q: `w=240&h=240&m=6`, w: 0, h: 0 },
            xl: { q: `w=240&h=240&m=6`, w: 0, h: 0 }
        },
        lazyload: true
    };

    const isLoading = props.data.productAvailableQuantity.status === 'LOADING';
    if (isLoading) {
        props.callbacks.changeUpdatingDimension(false);
    }

    const isLoadingDeliveryOptions = typeName !== 'quickview' && props.data.deliveryOptions?.status === 'LOADING';
    if (isLoadingDeliveryOptions && props.callbacks.changeUpdatingDeliveryOptions) {
        props.callbacks.changeUpdatingDeliveryOptions(false);
    }

    telemetryContent = getTelemetryObject(props.context.request.telemetryPageName!, props.friendlyName, props.telemetry);

    // check if the product delivery mode is electronic
    const emailDeliveryModeCode = props.context.actionContext.requestContext.channel?.EmailDeliveryModeCode;
    const deliveryOptions = props.data.deliveryOptions?.result;
    const isEmailDelivery =
        deliveryOptions &&
        deliveryOptions.DeliveryOptions &&
        ArrayExtensions.hasElements(deliveryOptions.DeliveryOptions) &&
        deliveryOptions.DeliveryOptions[0].Code === emailDeliveryModeCode;

    const successfulATC = props.state.successfulATC;

    return {
        ContainerProps: {
            className: 'ms-buybox__add-to-cart-container'
        },
        button: product && (
            <>
                <AddToCartComponent
                    addToCartText={resources.addToCartText}
                    addToCartProductsText={resources.addToCartProductsText}
                    outOfStockText={resources.outOfStockText}
                    mfrmOutOfStockCustomText={resources.mfrmOutOfStockText}
                    mfrmContinueShoppingText={resources.mfrmContinueShoppingText}
                    mfrmContinueShoppingLink={lastBreadcrumbCategoryLink}
                    mfrmOutOfStockSmallParcell={outOfStockSmallParcel || outOfStockSmallParcelState ? true : false}
                    outOfStockSmallParcel={outOfStockSmallParcel}
                    navigationUrl={getUrlSync('cart', context.actionContext)}
                    quantity={quantity}
                    data={{ product: product, price: props.state.productPrice, productPrice }}
                    context={context}
                    id={id}
                    typeName={typeName}
                    onError={onAddToCartFailed}
                    getSelectedProduct={selectedProduct}
                    productAvailability={productAvailability}
                    isLoading={isLoading}
                    isUpdatingDimension={isUpdatingDimension}
                    changeUpdatingDimension={props.callbacks.changeUpdatingDimension}
                    isLoadingDeliveryOptions={isLoadingDeliveryOptions}
                    isUpdatingDeliveryOptions={isUpdatingDeliveryOptions}
                    changeUpdatingDeliveryOptions={props.callbacks.changeUpdatingDeliveryOptions}
                    dialogStrings={dialogStrings}
                    gridSettings={props.context.request.gridSettings}
                    imageSettings={defaultImageSettings}
                    telemetryContent={telemetryContent}
                    isAddServiceItemToCart={isServiceItem}
                    isPriceKeyedIn={props.state.isPriceKeyedIn}
                    customPriceAmount={props.state.keyInPriceAmount}
                    isCustomPriceSelected={props.state.isCustomPriceSelected}
                    maximumKeyInPrice={props.config.maximumKeyInPrice}
                    minimumKeyInPrice={props.config.minimumKeyInPrice}
                    defaultMinimumKeyInPrice={defaultMinimumKeyInPrice}
                    defaultMaximumKeyInPrice={defaultMaximumKeyInPrice}
                    isOrderQuantityLimitsFeatureEnabled={_isOrderQuantityLimitsFeatureEnabled(props)}
                    isAddEmailDeliveryItemToCart={isEmailDelivery}
                    itemOutOfMarket={itemOutOfMarket}
                    variantOutOfStock={variantOutOfStock}
                    extensionProps={props.extensionProps}
                    allProductVariants={props.data.allProductVariants.result}
                    productCategoryName={categoryName}
                    productBrand={productBrandName}
                    successfulATC={successfulATC}
                    updateSuccessfulATC={props.updateSuccessfulATC}
                    variantIdForTracking={props.state.variantIdForTracking}
                    adjustableItem={adjustableItem}
                    pillow={pillow}
                    protector={protector}
                    allVariantOOS={allVariantOOS}
                />
            </>
        ),
        errorBlock: (
            <BuyboxErrorBlock
                configureErrors={configureErrors}
                quantityError={quantityError}
                customAmountError={customAmountError}
                otherError={otherError}
                resources={resources}
                showError={errorHost === 'ADDTOCART'}
            />
        )
    };
}

const _getProductType = (shippingInformation: string | undefined): string => {
    if (shippingInformation && shippingInformation.toLowerCase() === 'delivery') {
        return 'Core';
    }
    if (shippingInformation && shippingInformation.toLowerCase() === 'parcel') {
        return 'Small Parcel';
    }
    if (shippingInformation && shippingInformation.toLowerCase() === 'drop ship') {
        return 'Drop Ship';
    }
    return '';
};

const _isOrderQuantityLimitsFeatureEnabled = (props: IBuyboxViewPropsExtended): boolean | undefined => {
    const defaultOrderQuantityLimitsFeatureConfig = props.context?.request?.app?.platform?.enableDefaultOrderQuantityLimits;
    if (defaultOrderQuantityLimitsFeatureConfig === 'none') {
        return false;
    }

    if (defaultOrderQuantityLimitsFeatureConfig === 'all') {
        return true;
    }

    const customerInfo = props.data.customerInformation.result;
    return (
        customerInfo &&
        ((defaultOrderQuantityLimitsFeatureConfig === 'b2b' && customerInfo.IsB2b) ||
            (defaultOrderQuantityLimitsFeatureConfig === 'b2c' && !customerInfo.IsB2b))
    );
};
